// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".headerContainBox1_Xm7dfd .containBox1_skEEQD {\n  font-size: 20px;\n}\n.headerContainBox1_Xm7dfd .flexGrow1_pgnOZb {\n  flex-grow: 1;\n}\n.headerContainBox1_Xm7dfd .menuIcon_LsqbXB {\n  width: 5vw;\n  height: 5vw;\n}\n", "",{"version":3,"sources":["webpack://src/component/messageNotify/messageNotify.module.less"],"names":[],"mappings":"AAAA;EAGI,eAAA;AADJ;AAFA;EAQI,YAAA;AAHJ;AALA;EAYI,UAAA;EACA,WAAA;AAJJ","sourcesContent":[".headerContainBox1 {\n\n  .containBox1{\n    font-size: 20px;\n    //background-color: green;\n  }\n\n  .flexGrow1 {\n    flex-grow: 1;\n  }\n\n  .menuIcon{\n    width: 5vw;\n    height: 5vw;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerContainBox1": "headerContainBox1_Xm7dfd",
	"containBox1": "containBox1_skEEQD",
	"flexGrow1": "flexGrow1_pgnOZb",
	"menuIcon": "menuIcon_LsqbXB"
};
export default ___CSS_LOADER_EXPORT___;
